import { useState, useEffect } from 'react';
import axios from 'axios';
import HourlySmoothChart from './HourlySmoothChart';
import IconActivity from '../../components/icons/IconActivity';
import language from '../../variables/language';

export default function TelegramUsageChart() {
    const lang = language[language.lang];
    const [timeline, setTimeline] = useState([]);
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        axios.get('/api/messages/last-activity', { withCredentials: true })
            .then(response => setTimeline(response.data))
            .catch(err => console.error(err))
            .finally(() => setStatus('done'));
    }, []);

    return (
        <div className='telegram-usage-wrapper dashboard-component'>
            <div className='header-dahs-elem'>
                <IconActivity style={{ width: 30, height: 30, fill: 'var(--dashboard-header-icon-color)' }} />
                <p className='txt-c'>{lang.hourlyTelegramUsage}</p>
            </div>
            {status === 'loading' ? (
                <div className='skeleton-block telegram-chart-skeleton'></div>
            ) : (
                <HourlySmoothChart
                    data={timeline}
                    lineColor="#3ab4e0"
                    fillColor="rgba(51, 234, 170, 0.3)"
                    backgroundColor="transparent"
                    containerHeight={150}
                />
            )}
        </div>
    );
}